const getIsoWeekNumber = (d) => {
  if (!d) d = new Date();
  // Copy date so don't modify original
  d = new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()));
  // Set to nearest Thursday: current date + 4 - current day number
  // Make Sunday's day number 7
  d.setUTCDate(d.getUTCDate() + 4 - (d.getUTCDay()||7));
  // Get first day of year
  const yearStart = new Date(Date.UTC(d.getUTCFullYear(),0,1));
  // Calculate full weeks to nearest Thursday
  const year = d.getUTCFullYear();
  const weekNumber = Math.ceil(( ( (d - yearStart) / 86400000) + 1)/7);
  const weekString = `${weekNumber < 10 ? '0' : ''}${weekNumber}`;
  const fullWeekString = `${year}-W${weekString}`;

  return { year, weekString, fullWeekString, weekNumber };
}

const getIsoWeek = (weekNumber, year) => {
  if (!weekNumber && !year) {
    const currentWeek = getIsoWeekNumber();
    weekNumber = currentWeek.weekNumber;
    year = currentWeek.year;
  }

  // ISO 8601: Week 1 is the week with the first Thursday of the year
  // First, find the first Thursday of the year
  const firstDayOfYear = new Date(Date.UTC(year, 0, 1));
  const dayOfWeek = firstDayOfYear.getUTCDay() || 7; // Convert Sunday from 0 to 7

  // Calculate days to first Thursday (4 is Thursday in ISO)
  const daysToFirstThursday = (4 - dayOfWeek + 7) % 7;

  // Find the first Thursday
  const firstThursday = new Date(Date.UTC(year, 0, 1 + daysToFirstThursday));

  // The Monday of week 1 is 3 days before the first Thursday
  const firstMondayOfWeek1 = new Date(firstThursday);
  firstMondayOfWeek1.setUTCDate(firstThursday.getUTCDate() - 3);

  // Calculate the start date (Monday) of the requested week
  const startDate = new Date(firstMondayOfWeek1);
  startDate.setUTCDate(firstMondayOfWeek1.getUTCDate() + (weekNumber - 1) * 7);

  // Calculate the end date (Sunday) of the requested week
  const endDate = new Date(startDate);
  endDate.setUTCDate(startDate.getUTCDate() + 6);

  return { startDate, endDate };
}

// CALENDAR quarter (Q3 = juillet-août-septembre), local dates like the month and
// semester presets. Never ISO-week quarters: those started Q3 2026 on June 29,
// overlapped S1, and left Dec 28-31 of a 53-week year in no quarter at all.
const getCalendarQuarter = (quarterNumber, year) => {
  const startMonth = (quarterNumber - 1) * 3;
  return {
    startDate: new Date(year, startMonth, 1),
    endDate: new Date(year, startMonth + 3, 0), // day 0 = last day of the quarter's 3rd month
  };
}

const getIsoMonth = (d) => {
  if (!d) d = new Date();
  const year = d.getUTCFullYear();
  const month = d.getUTCMonth() + 1; // Adding 1 because getUTCMonth() returns 0-11
  const monthString = `${month < 10 ? '0' : ''}${month}`;
  const fullMonthString = `${year}-${monthString}`;
  return { year, month, monthString, fullMonthString };
}

export { getIsoWeekNumber, getIsoWeek, getCalendarQuarter, getIsoMonth };